"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Section["default"];
  }
});
var _Section = _interopRequireDefault(require("./Section"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }